// Term of Service configuration
export const termsLastUpdate = '2019-05-01 00:00:00+00:00'
export const termsOfUseURL = 'https://ta-mk2.helpscoutdocs.com/article/112-travel-analytics-website-terms-of-use'
export const privacyPolicyURL = 'https://ta-mk2.helpscoutdocs.com/article/111-travel-analytics-privacy-policy'
// export const introVideoURL = 'https://www.youtube.com/embed/QGQ7xPO053g'
export const introVideoURL = 'https://temp-client-logos.s3-ap-southeast-2.amazonaws.com/videos/Travel+Analytics+-+Business+Travel+Reporting%2C+Intelligence+%26+Dashboard.mp4'
